export default "__VITE_ASSET__DcCwMLxH__"